import axios from 'axios';
import { put , call} from 'redux-saga/effects';
import { showNotification } from '../actionCreators/notification';

const withoutNotification = "Low balance";

export function* callApi(url, method, options, headers, api) {      
    const axiosConfig = {
        method,
        headers,
        url
    };
    
    
    if (options) {
        if (method === 'GET') axiosConfig.params = options;
        else axiosConfig.data = options;
    }
    try {
        const response = yield call(axios, axiosConfig);
        return response;
    } catch (e) {
        let errorMessage;
        if(
            !!e.response && 
            !!e.response.data && 
            !!e.response.data.result && 
            !!e.response.data.result.message
        ) {
            errorMessage = e.response.data.result.message;
        } else if (
            !!e.response && 
            !!e.response.data && 
            !!e.response.data.err &&
            !!e.response.data.err.message) {
            errorMessage = e.response.data.err.message;
        } else if (
            !!e.response && 
            !!e.response.data && 
            !!e.response.data.error &&
            !!e.response.data.error.message) {
            errorMessage = e.response.data.error.message;
        } else {
            errorMessage = e.message;
        }
        if(!withoutNotification.includes(errorMessage))
            yield put(showNotification({message: errorMessage, appearance: 'error'}));
        throw e;
    }
}
